<template>
<div>


<div class="quiz_progress mb-4">

<div  class="quiz_progress_home_item"
v-tooltip.bottom="{ value: $store.state.languages.lang_phrases.baslangic_sayfasina_don, disabled: false,class: 'custom-top-tooltip' }"
>
<div class="quiz_progress_item_inner animate_class"  @click="gotoHome()">
<i class="pi pi-spin pi-spinner mt-2 " style="font-size: 1em;" v-if="return_home_loader"></i>
<i class="pi pi-home" v-else></i>
</div>
</div>

<FlowProcess></FlowProcess>
</div>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="!loading">
<div class="quiz_progress_item " v-for="video in $store.state.evaluation.flow_videos.videos">
<div class="quiz_progress_item_inner  quiz_progress_item_video_inner animate_class" :class="{ quiz_progress_item_inner_deactive: !video.allow_display }">
  

<div class="grid pt-3 pb-3">
<div class="col-10 md:col-11 pl-3 sortable_element_section_name pt-1 pb-0"  @click="gotoVideo(video)" >
<!--<span class="material-icons-outlined md-24 mr-2">
smart_display
</span>-->

<span>{{getTheTranslation(video,"translation")}}  <i class="pi pi-clock mr-2 ml-4 pt-1"></i><b class="">{{ $filters.videoduration( video.duration)}}</b></span>

<!--
<template v-if="video.translations.length">


<span v-for="translation in video.translations" v-show="translation.language_id == $store.state.auth.user.preflang_id">{{translation.translation}} <i class="pi pi-clock mr-2 ml-4 pt-1"></i><b class="">{{$filters.videoduration( video.duration)}}</b></span>
</template>
<template v-else>

<span>{{video.name}}  <i class="pi pi-clock mr-2 ml-4 pt-1"></i><b class="">{{ $filters.videoduration( video.duration)}}</b></span>
</template>

-->
  

</div>


<div class="col-2 md:col-1 sortable_element_section_name pt-1 pb-0">
  <template v-if="video.display_status=='in_progress'">
    <span class="material-icons-outlined md-24 mr-2 "
    :class="video.display_icon_color"
    v-tooltip.left="{ value: $store.state.languages.lang_phrases.beklemede, disabled: false,class: 'custom-top-tooltip' }"
    >
    mode_standby
    </span>
  </template>

  <template v-if="video.display_status=='ended'">
    <span class="material-icons-outlined md-24 mr-2 "
    :class="video.display_icon_color"
    v-tooltip.left="{ value: $store.state.languages.lang_phrases.tamamlandi, disabled: false,class: 'custom-top-tooltip' }"
    >
    check_circle
    </span>
  </template>

  <template v-if="video.display_status=='ready'">
  <span class="material-icons-outlined md-24 mr-2 "
  :class="video.display_icon_color"
  v-tooltip.left="{ value: $store.state.languages.lang_phrases.baslanmadi, disabled: false,class: 'custom-top-tooltip' }"
  >
    not_started
    </span>
</template>

  

</div>


</div>
</div>
</div>
</template>


</div>
</template>

<script>
export default {

  name: 'EvaluationEducation',

  data () {
    return {
      loading:true,
      return_home_loader:false,
    }
  },
  computed:{
    welcometext()
    {
      let preflang = this.$store.state.auth.user.preflang
      if(this.$store.state.evaluation.evaluation)
      {
        let text = this.$store.state.evaluation.evaluation.flow.translations.find((item)=>{return item.language_id == preflang.id})
        return text.description
      }

      return ""
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    async getData()
    {
        this.loading = await true
        let audit_education_data = await this.generalApiGet("audit/get_audit_education_data/"+this.$route.params.id)
        await console.log(audit_education_data)
       

        //set display states
        for(let video of audit_education_data.videos)
        {
            video.allow_display = true
          if(video.progresses.length)
          {
              if(video.progresses[0].status=="in_progress")
              {
                video.display_status = "in_progress"
                video.display_icon_color ="text-cyan-500"
              }
              if(video.progresses[0].status=="ended")
              {
                video.display_status = "ended"
                video.display_icon_color ="text-green-400"
              }
          }
          else
          {
            video.display_status = "ready"
            video.display_icon_color ="text-yellow-400"
          }
        }
        //set display states
        if(this.$store.state.evaluation.evaluation.flow.educationsettings.allow_unordered_display)
        {
          for(let video of audit_education_data.videos)
          {
            video.allow_display = await false
            video.display_icon_color ="text-gray-500"
          }
          for (let i = 0; i < audit_education_data.videos.length; i++) 
          {
                if(audit_education_data.videos[i].display_status =="ended")
                {
                  audit_education_data.videos[i].allow_display = await true 
                  audit_education_data.videos[i].display_icon_color ="text-green-400"                                
                }
                else
                {
                    audit_education_data.videos[i].allow_display = await true
                    if(audit_education_data.videos[i].display_status=="in_progress")
                    {
                      audit_education_data.videos[i].display_icon_color ="text-cyan-500" 
                    }
                    if(audit_education_data.videos[i].display_status=="ready")
                    {
                      audit_education_data.videos[i].display_icon_color ="text-yellow-400" 
                    }
                    break;
                }
          }
        }
         console.log("bune")
        console.log(audit_education_data.videos)


        


        this.$store.dispatch('evaluation/setFlowVideos',audit_education_data) 
        await this.calculateEducationProgress("first_init")
        this.loading = await false
    },
    gotoVideo(video)
    {
      if(this.$store.state.evaluation.evaluation.flow.educationsettings.allow_unordered_display)
      {
        if(video.allow_display)
        {
          this.$router.push({ name: 'EvaluationEducationVideo', params: { video_id:video.id } })
        }
      }
      else
      {
        this.$router.push({ name: 'EvaluationEducationVideo', params: { video_id:video.id } })
      }
      
    },
    async gotoHome()
    {
      let userroles = await this.$store.state.auth.user.userroles
      let roletype = "admin"
      for(let i=0; i<userroles.length;i++)
      {
        if(userroles[i].name=="supplier")
        {
          roletype = "supplier"
          break;
        }
       
      }

      this.return_home_loader = await true
      //console.log(this.$store.state.evaluation.evaluation)
      let projectsupplier = await this.silentApiGet("audit/get_project_supplier_id/"+this.$store.state.evaluation.evaluation.uuid)
      await console.log(projectsupplier)
      this.return_home_loader = await true
      //return false
      if(roletype=="supplier")
      {
        await this.$router.push({ name: 'SupplierBrandFlowSummary',params:{supplier_uuid:projectsupplier.supplier.uuid,project_id:projectsupplier.uuid,flow_id:this.$store.state.evaluation.evaluation.uuid} })
      }
      else
      {
        await this.$router.push({ name: 'SupplierProjectFlowSummary',params:{id:projectsupplier.supplier_id,project_id:projectsupplier.uuid,flow_id:this.$store.state.evaluation.evaluation.uuid} })
      }
      
    },
    gotoList()
    {
      this.$router.push({ name: 'EvaluationEducation' })
    },
  },
}
</script>

<style lang="css" scoped>
</style>